import React from "react";

export function PolarAnswer(props) {
  const isSelected = props.active === props.value;

  // Use a native title tooltip instead of react-tooltip: PolarAnswer mounts/unmounts on
  // every question transition, and rendering a react-tooltip <Tooltip> per answer button
  // (all sharing one id) added effect/observer churn that crashed the commit phase
  // ("n is not a function"). The label text is also shown in the polar instruction line.
  return (
    <button
      id={props.value + "polar"}
      title={props.tooltipContent}
      className={`animate__animated animate__faster polar-answering-button  ${props.btnClassName} ${isSelected && " selected"}`}
      onClick={() => props.HandleAnswering(props.value, props.value + "polar")}
    >
      {props.label}
    </button>
  );
}
